document.addEventListener("DOMContentLoaded", function () {
    const selectedTableBody = document.getElementById("selected-components-tbody");
    const totalPriceEl = document.getElementById("total-price");
    let total = 0;
    const selectedItems = [];

    function formatPrice(price) {
        return `₹${price.toLocaleString("en-IN")}`;
    }

    function detectCategoryFromTitle(title, fallbackCategory = '') {
        title = title.toLowerCase();
        let detectedCategory = fallbackCategory?.trim().toLowerCase() || '';

        const categoryMap = {
            'case': 'cabinet',
            'smps': 'psu',
            'graphic cards': 'gpu',
            'graphics': 'gpu',
            'coolers': 'cooler'
        };

        if (detectedCategory && categoryMap[detectedCategory]) {
            detectedCategory = categoryMap[detectedCategory];
        }

        if (['cpu', 'motherboard', 'ram', 'storage', 'psu', 'cabinet', 'cooler', 'gpu'].includes(detectedCategory)) {
            return detectedCategory;
        }

        if (title.includes("ryzen") || title.includes("processor")) return "cpu";
        if (title.includes("motherboard") || title.includes("b450") || title.includes("z790") || title.includes("b760m") || title.includes("z890-e") || title.includes("h510m-e")) return "motherboard";
        if (title.includes("ram") || title.includes("ddr")) return "ram";
        if (title.includes("ssd") || title.includes("hdd") || title.includes("nvme")) return "storage";
        if (title.includes("power supply unit") || title.includes("psu") || title.includes("smps")) return "psu";
        if (title.includes("cabinet") || title.includes("case") || title.includes("chassis")) return "cabinet";
        if (title.includes("coolers") || title.includes("cooler") || title.includes("liquid") || title.includes("fan") || title.includes("aio")) return "cooler";
        if (title.includes("graphic cards") || title.includes("gpu") || title.includes("rtx") || title.includes("gtx") || title.includes("graphics")) return "gpu";

        return "other";
    }

    function getSelectedAttribute(category, attribute) {
        const item = selectedItems.find(i => i.category.toLowerCase() === category.toLowerCase());
        const value = item ? item[attribute] : null;
        console.log(`Getting attribute '${attribute}' for category '${category}': ${value}`);
        return value;
    }

    function compatible(card, sectionCategory) {
        const cardSocket = card.dataset.socket?.toLowerCase() || "";
        const cardRam = card.dataset.ram?.toLowerCase() || "";
        const cardFormFactor = card.dataset.factor?.trim().toLowerCase() || "";
        const cardCoolerHeight = card.dataset.cooler || "";
        const cardGpuLength = card.dataset.gpu || "";
        const cardPsuWattage = card.dataset.psu || "";

        const selectedCPUSocket = getSelectedAttribute("cpu", "socket");
        const selectedMotherboardSocket = getSelectedAttribute("motherboard", "socket");
        const selectedMotherboardRam = getSelectedAttribute("motherboard", "ram");
        const selectedMotherboardFormFactor = getSelectedAttribute("motherboard", "factor")?.trim().toLowerCase() || "";
        const selectedCabinetFormFactor = getSelectedAttribute("cabinet", "factor")?.trim().toLowerCase() || "";
        const selectedCoolerHeight = getSelectedAttribute("cabinet", "cooler");
        const selectedGpuLength = getSelectedAttribute("cabinet", "gpu");
        const selectedGpuWattage = getSelectedAttribute("gpu", "psu");

        if (sectionCategory === "motherboard" && selectedCPUSocket) {
            return cardSocket === selectedCPUSocket;
        }
        if (sectionCategory === "cpu" && selectedMotherboardSocket) {
            return cardSocket === selectedMotherboardSocket;
        }
        if (sectionCategory === "ram" && selectedMotherboardRam) {
            return cardRam === selectedMotherboardRam;
        }
        if (sectionCategory === "cabinet" && selectedMotherboardFormFactor) {
            return cardFormFactor.split(',').map(s => s.trim()).includes(selectedMotherboardFormFactor);
        }
        if (sectionCategory === "cooler" && selectedCabinetFormFactor && selectedCoolerHeight) {
            return cardCoolerHeight ? parseFloat(cardCoolerHeight) <= parseFloat(selectedCoolerHeight) : true;
        }
        if (sectionCategory === "gpu" && selectedCabinetFormFactor && selectedGpuLength) {
            return cardGpuLength ? parseFloat(cardGpuLength) <= parseFloat(selectedGpuLength) : true;
        }
        if (sectionCategory === "psu" && selectedGpuWattage) {
            return cardPsuWattage ? parseFloat(cardPsuWattage) >= parseFloat(selectedGpuWattage) : true;
        }

        return true;
    }

    /* Accordion Toggle with Event Delegation */
    document.body.addEventListener("click", (event) => {
        const btn = event.target.closest('.builder-toggle');
        if (!btn) return;

        console.log(`Accordion toggle clicked for: ${btn.textContent || 'unknown'}`);

        let content = btn.nextElementSibling;
        if (!content || !content.classList) {
            const section = btn.closest('.builder-section');
            content = section ? section.querySelector('.builder-section-content') : null;
        }
        if (!content || !content.classList) {
            content = btn.parentElement.querySelector('.content, .section-content, .accordion-content, [class*="content"]');
        }
        if (!content || !content.classList) {
            let sibling = btn.nextElementSibling;
            while (sibling && (sibling.tagName === 'BUTTON' || sibling.tagName === 'H1' || sibling.tagName === 'H2' || sibling.tagName === 'H3')) {
                sibling = sibling.nextElementSibling;
            }
            content = sibling;
        }

        if (!content || !content.classList) {
            console.error("Accordion content not found for button:", btn);
            return;
        }

        const hiddenClass = 'hidden';
        content.classList.toggle(hiddenClass);
        console.log(`Toggled section: ${btn.textContent || 'unknown'}, Hidden: ${content.classList.contains(hiddenClass)}`);

        const icon = btn.querySelector(".builder-icon");
        if (icon) {
            icon.textContent = content.classList.contains(hiddenClass) ? "+" : "✖";
        } else {
            console.warn("Icon not found for button:", btn);
        }

        const section = btn.closest('.builder-section');
        if (section && !content.classList.contains(hiddenClass)) {
            section.updateBrands();
            section.updateTypes();
            section.refresh();
        }
    });

    /* Quantity buttons */
    document.querySelectorAll('.builder-qty-wrapper').forEach(wrapper => {
        const minusBtn = wrapper.querySelector('.qty-btn.minus');
        const plusBtn = wrapper.querySelector('.qty-btn.plus');
        const input = wrapper.querySelector('input.qty');

        minusBtn.addEventListener('click', () => {
            let currentValue = parseInt(input.value);
            if (currentValue > 1) input.value = currentValue - 1;
        });

        plusBtn.addEventListener('click', () => {
            let currentValue = parseInt(input.value);
            input.value = currentValue + 1;
        });

        input.addEventListener('input', () => {
            if (input.value < 1) input.value = 1;
        });
    });

    /* Add to Build */
    document.querySelectorAll(".add-to-build").forEach(button => {
        button.addEventListener("click", () => {
            const title = button.dataset.title;
            const price = parseFloat(button.dataset.price.replace(/[^\d.-]/g, ''));
            const variantId = button.dataset.id;
            const wrapper = button.closest('.product-row') || button.closest('.builder-qty-wrapper');
            const input = wrapper?.querySelector('input.qty');
            const quantity = input ? Math.max(1, parseInt(input.value)) : 1;
            const socket = button.dataset.socket?.toLowerCase() || "";
            const ram = button.dataset.ram?.toLowerCase() || "";
            const factor = button.dataset.factor?.toLowerCase() || "";
            const cooler = button.dataset.cooler || "";
            const gpu = button.dataset.gpu || "";
            const psu = button.dataset.psu || "";
            const category = button.dataset.category?.trim().toLowerCase() || detectCategoryFromTitle(title, button.dataset.category);

            console.log("Add to Build clicked:", { title, category, socket, ram, factor, cooler, gpu, psu, variantId });

            const existingIndex = selectedItems.findIndex(item => item.id === variantId);

            if (existingIndex !== -1) {
                selectedItems.splice(existingIndex, 1);
                const row = selectedTableBody.querySelector(`tr[data-id="${variantId}"]`);
                if (row) {
                    selectedTableBody.removeChild(row);
                    total -= price * selectedItems[existingIndex]?.quantity || price * quantity;
                    totalPriceEl.textContent = formatPrice(total);
                }
                button.textContent = "Add to List";
                button.classList.remove("added");
                console.log("Removed item:", variantId);
            } else {
                const selectedCPUSocket = getSelectedAttribute("cpu", "socket");
                const selectedMotherboardSocket = getSelectedAttribute("motherboard", "socket");
                const selectedMotherboardRam = getSelectedAttribute("motherboard", "ram");
                const selectedMotherboardFormFactor = getSelectedAttribute("motherboard", "factor");
                const selectedCabinetFormFactor = getSelectedAttribute("cabinet", "factor");
                const selectedCoolerHeight = getSelectedAttribute("cabinet", "cooler");
                const selectedGpuLength = getSelectedAttribute("cabinet", "gpu");
                const selectedGpuWattage = getSelectedAttribute("gpu", "psu");

                if (category === "motherboard" && selectedCPUSocket && socket && socket !== selectedCPUSocket) {
                    alert(`This motherboard is incompatible with the selected CPU (socket: ${selectedCPUSocket}).`);
                    console.log("Blocked incompatible motherboard:", { title, socket, selectedCPUSocket });
                    return;
                }
                if (category === "cpu" && selectedMotherboardSocket && socket && socket !== selectedMotherboardSocket) {
                    alert(`This CPU is incompatible with the selected motherboard (socket: ${selectedMotherboardSocket}).`);
                    console.log("Blocked incompatible CPU:", { title, socket, selectedMotherboardSocket });
                    return;
                }
                if (category === "ram" && selectedMotherboardRam && ram && ram !== selectedMotherboardRam) {
                    alert(`This RAM is incompatible with the selected motherboard (RAM type: ${selectedMotherboardRam}).`);
                    console.log("Blocked incompatible RAM:", { title, ram, selectedMotherboardRam });
                    return;
                }
                if (category === "cabinet" && selectedMotherboardFormFactor && factor) {
                    const supportedFactors = factor.split(',').map(s => s.trim());
                    if (!supportedFactors.includes(selectedMotherboardFormFactor)) {
                        alert(`This cabinet is incompatible with the selected motherboard (form factor: ${selectedMotherboardFormFactor}).`);
                        console.log("Blocked incompatible cabinet:", { title, factor, selectedMotherboardFormFactor });
                        return;
                    }
                }
                if (category === "cooler" && selectedCabinetFormFactor && cooler && selectedCoolerHeight && parseFloat(cooler) > parseFloat(selectedCoolerHeight)) {
                    alert(`This cooler is incompatible with the selected cabinet (max cooler height: ${selectedCoolerHeight} mm).`);
                    console.log("Blocked incompatible cooler:", { title, cooler, selectedCoolerHeight });
                    return;
                }
                if (category === "gpu" && selectedCabinetFormFactor && gpu && selectedGpuLength && parseFloat(gpu) > parseFloat(selectedGpuLength)) {
                    alert(`This GPU is incompatible with the selected cabinet (max GPU length: ${selectedGpuLength} mm).`);
                    console.log("Blocked incompatible GPU:", { title, gpu, selectedGpuLength });
                    return;
                }
                if (category === "psu" && selectedGpuWattage && psu && parseFloat(psu) < parseFloat(selectedGpuWattage)) {
                    alert(`This PSU is incompatible with the selected GPU (minimum wattage: ${selectedGpuWattage} W).`);
                    console.log("Blocked incompatible PSU:", { title, psu, selectedGpuWattage });
                    return;
                }

                if (category === "cpu" && selectedItems.some(item => item.category === "cpu")) {
                    alert("Only one CPU can be selected.");
                    return;
                }
                if (category === "motherboard" && selectedItems.some(item => item.category === "motherboard")) {
                    alert("Only one motherboard can be selected.");
                    return;
                }

                const row = document.createElement("tr");
                row.innerHTML = `
                    <td>${category.toUpperCase()}</td>
                    <td>${title}</td>
                    <td>${formatPrice(price)}</td>
                    <td>${quantity}</td>
                    <td><button class="pc-build remove-btn" data-id="${variantId}">Remove</button></td>
                `;
                row.dataset.id = variantId;
                row.dataset.price = price;
                row.dataset.qty = quantity;
                row.dataset.category = category;

                selectedTableBody.appendChild(row);
                selectedItems.push({ id: variantId, quantity, category, socket, ram, factor, cooler, gpu, psu });
                total += price * quantity;
                totalPriceEl.textContent = formatPrice(total);

                button.textContent = "Remove from List";
                button.classList.add("added");
                console.log("Added item to selectedItems:", selectedItems);
            }

            /* Refresh all open sections */
            document.querySelectorAll('.builder-section').forEach(sec => {
                const content = sec.querySelector('.builder-section-content');
                if (content && !content.classList.contains('hidden')) {
                    sec.updateBrands();
                    sec.updateTypes();
                    sec.refresh();
                }
            });
        });
    });

    /* Remove from Build */
    selectedTableBody.addEventListener("click", (event) => {
        const removeBtn = event.target.closest(".remove-btn");
        if (removeBtn) {
            const variantId = removeBtn.dataset.id;
            const row = removeBtn.closest("tr");
            const price = parseFloat(row.dataset.price);
            const quantity = parseInt(row.dataset.qty);
            const category = row.dataset.category;

            selectedItems.splice(selectedItems.findIndex(item => item.id === variantId), 1);
            selectedTableBody.removeChild(row);
            total -= price * quantity;
            totalPriceEl.textContent = formatPrice(total);

            const addButton = document.querySelector(`.add-to-build[data-id="${variantId}"]`);
            if (addButton) {
                addButton.textContent = "Add to List";
                addButton.classList.remove("added");
            }

            /* Refresh all open sections */
            document.querySelectorAll('.builder-section').forEach(sec => {
                const content = sec.querySelector('.builder-section-content');
                if (content && !content.classList.contains('hidden')) {
                    sec.updateBrands();
                    sec.updateTypes();
                    sec.refresh();
                }
            });
        }
    });

    /* Add to cart */
    document.querySelector(".build-pc-cart").addEventListener("click", () => {
        if (selectedItems.length === 0) {
            alert("Add some items before going to cart.");
            return;
        }

        const items = selectedItems.map(item => ({
            id: item.id,
            quantity: item.quantity
        }));

        fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items })
        })
        .then(res => res.json())
        .then(() => {
            window.location.href = "/cart";
        })
        .catch(err => {
            alert("Something went");
            console.error(err);
        });
    });

    /* Filters: search, brand, type, etc */
    document.querySelectorAll('.builder-section').forEach(section => {
        const searchInput = section.querySelector('.search-bar');
        const brandSelect = section.querySelector('.brand-filter');
        const typeSelect = section.querySelector('.type-filter');
        const sortSelect = section.querySelector('.sort-by');
        const productList = section.querySelector('.component-table tbody');
        const cards = Array.from(productList.querySelectorAll('.product-row'));
        let displayLimit = 6;

        const sectionCategory = section.dataset.category?.trim().toLowerCase() || detectCategoryFromTitle(section.querySelector('.builder-toggle')?.textContent || '', section.dataset.category);

        /* Populate brand filter initially (will be updated dynamically) */
        if (brandSelect) {
            brandSelect.innerHTML = `<option value="">All Brands</option>`;
            const initialBrands = new Set();
            cards.forEach(card => {
                const brand = card.dataset.brand?.trim();
                if (brand) initialBrands.add(brand);
            });
            [...initialBrands].sort().forEach(brand => {
                brandSelect.appendChild(new Option(brand, brand));
            });
        }

        /* Define updateBrands */
        const updateBrands = () => {
            if (!brandSelect) return;
            const showOutOfStock = document.getElementById('show-out-of-stock').checked;
            const filteredBrands = new Set();
            cards.forEach(card => {
                const brand = card.dataset.brand?.trim() || "";
                const isOutOfStock = card.classList.contains('out-of-stock');
                const matchStock = showOutOfStock || !isOutOfStock;
                if (brand && compatible(card, sectionCategory) && matchStock) {
                    filteredBrands.add(brand);
                }
            });
            const previousValue = brandSelect.value;
            brandSelect.innerHTML = `<option value="">All Brands</option>`;
            [...filteredBrands].sort().forEach(brand => {
                const option = new Option(brand, brand);
                if (brand === previousValue) option.selected = true;
                brandSelect.appendChild(option);
            });
        };

        /* Define updateTypes */
        const updateTypes = () => {
            if (!typeSelect) return;
            const selectedBrand = brandSelect?.value.trim().toLowerCase() || '';
            const showOutOfStock = document.getElementById('show-out-of-stock').checked;
            const filteredTypes = new Set();
            cards.forEach(card => {
                const brand = card.dataset.brand?.trim().toLowerCase() || "";
                const type = card.dataset.type?.trim() || "";
                const isOutOfStock = card.classList.contains('out-of-stock');
                const matchesBrand = !selectedBrand || brand === selectedBrand;
                const matchStock = showOutOfStock || !isOutOfStock;
                if (type && compatible(card, sectionCategory) && matchesBrand && matchStock) {
                    filteredTypes.add(type);
                }
            });
            const previousValue = typeSelect.value;
            typeSelect.innerHTML = `<option value="">Choose Series</option>`;
            [...filteredTypes].sort().forEach(type => {
                const option = new Option(type, type);
                if (type === previousValue) option.selected = true;
                typeSelect.appendChild(option);
            });
        };

        /* Define refreshProductList */
        const refreshProductList = () => {
            const searchTerm = searchInput?.value.toLowerCase().trim() || '';
            const selectedBrand = brandSelect?.value.trim().toLowerCase() || '';
            const selectedType = typeSelect?.value.trim().toLowerCase() || '';
            const sortType = sortSelect?.value;
            const showOutOfStock = document.getElementById('show-out-of-stock').checked;

            console.log(`Updating display for section: ${sectionCategory}`, {
                searchTerm,
                selectedBrand,
                selectedType,
                showOutOfStock
            });

            let matchedCards = cards.filter(card => {
                const title = card.dataset.title?.toLowerCase() || "";
                const brand = card.dataset.brand?.toLowerCase() || "";
                const type = card.dataset.type?.toLowerCase() || "";
                const isOutOfStock = card.classList.contains('out-of-stock');

                const matchSearch = title.includes(searchTerm);
                const matchBrand = !selectedBrand || brand === selectedBrand;
                const matchType = !selectedType || type === selectedType;
                const matchStock = showOutOfStock || !isOutOfStock;
                const isCompatible = compatible(card, sectionCategory);

                return matchSearch && matchBrand && matchType && matchStock && isCompatible;
            });

            if (sortType) {
                const compare = {
                    "name-asc": (a, b) => a.dataset.title.localeCompare(b.dataset.title),
                    "price-asc": (a, b) => parseFloat(a.dataset.price) - parseFloat(b.dataset.price),
                    "price-desc": (a, b) => parseFloat(b.dataset.price) - parseFloat(a.dataset.price)
                }[sortType];
                if (compare) matchedCards.sort(compare);
            }

            cards.forEach(card => card.style.display = "none");
            matchedCards.slice(0, displayLimit).forEach(card => card.style.display = "table-row");

            const seeMoreBtn = section.querySelector("#see-more-btn");
            if (seeMoreBtn) {
                seeMoreBtn.style.display = matchedCards.length > displayLimit ? "inline-block" : "none";
            }
        };

        /* Attach to section */
        section.updateBrands = updateBrands;
        section.updateTypes = updateTypes;
        section.refresh = refreshProductList;

        /* Update brand filter when brand changes (but updateTypes first) */
        if (brandSelect) {
            brandSelect.addEventListener('change', () => {
                updateTypes();
                refreshProductList();
            });
        }

        /* Attach event listeners for filters */
        [searchInput, typeSelect, sortSelect].forEach(el => {
            el?.addEventListener("input", refreshProductList);
            el?.addEventListener("change", refreshProductList);
        });

        /* See more button */
        const seeMoreBtn = section.querySelector("#see-more-btn");
        if (seeMoreBtn) {
            seeMoreBtn.addEventListener('click', () => {
                displayLimit += 6;
                refreshProductList();
            });
        }

        /* Initial update (but accordion starts closed, will update on open) */
    });

    /* Out of Stock Toggle */
    const outOfStockToggle = document.getElementById('show-out-of-stock');
    document.querySelectorAll('.product-row.out-of-stock').forEach(row => row.style.display = 'none');

    outOfStockToggle.addEventListener('change', () => {
        document.querySelectorAll('.builder-section').forEach(sec => {
            const content = sec.querySelector('.builder-section-content');
            if (content && !content.classList.contains('hidden')) {
                sec.updateBrands();
                sec.updateTypes();
                sec.refresh();
            }
        });
    });
});